export const CANCELLED_MESSAGE_TEXT = 'Message cancelled by user';
export const DEFAULT_FAILED_MESSAGE = 'Message failed.';
